<template>
    <div class="graph-button">
        <a
            href=""
            class="uk-icon-image uk-svg uk-border-circle graph-icon uk-align-center uk-text-middle"
            @click="switchMode"
        >
            <img :src="require('@/assets/images/icons/icon-graph.svg')" />
        </a>
    </div>
</template>

<script lang="js">
import Vue from "vue";
export default Vue.extend({
    name: "GraphButton",
    methods: {
        switchMode(event) {
            event.preventDefault();
            this.$emit("modeSwitch", true);
        },
    },
});
</script>
